import React from 'react'
import Link from 'gatsby-link'

const Header = () => (
  <div>
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '2em',
      }}
    >
      <h1>
        <Link
          to='/'
          style={{
            color: '#FFF',
            textDecoration: 'none',
            textTransform: 'uppercase',
            letterSpacing: '10px',
          }}
        >
          <span className="word">M<span className="lite">att</span></span>&nbsp;
          <span className="word">W<span className="lite">ard</span></span>&nbsp;
          <span className="word">Designs</span>
        </Link>
      </h1>
    </div>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js